import { Trash01 } from "@untitledui/icons";
import { useState } from "react";
import { DialogTrigger, Heading } from "react-aria-components";
import { useDeleteCandidateList } from "@/api/candidate-lists";
import { useDeleteCreatorList } from "@/api/creator-lists";
import { Dialog, Modal, ModalOverlay } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { CloseButton } from "@/components/base/buttons/close-button";
import { error, success } from "@/providers/ToastProvider";

type Props = { id: string; onDelete: () => void; type?: "creator" | "candidate" };

export const DeleteCreatorListModal = ({ id, onDelete, type = "creator" }: Props) => {
  const [open, setOpen] = useState(false);
  const { mutateAsync: mutateCreator } = useDeleteCreatorList();
  const { mutateAsync: mutateCandidate } = useDeleteCandidateList();
  const mutateAsync = type === "candidate" ? mutateCandidate : mutateCreator;

  const onSubmit = async () => {
    try {
      await mutateAsync({ id });
      success("Creator list deleted");
      onDelete();

      setOpen(false);
    } catch (err) {
      error("Failed to delete creator list");
      throw err;
    }
  };

  return (
    <DialogTrigger isOpen={open} onOpenChange={setOpen}>
      <Button iconLeading={Trash01} color="secondary">
        Delete List
      </Button>
      <ModalOverlay isDismissable>
        <Modal>
          <Dialog>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="min-w-96 relative w-full overflow-hidden rounded-2xl bg-primary shadow-none transition-all sm:w-full">
                <CloseButton
                  onClick={() => setOpen(false)}
                  theme="light"
                  size="lg"
                  className="absolute top-3 right-3"
                />
                <div className="flex flex-col gap-4 px-4 pt-5 mr-4 sm:px-6 sm:pt-6">
                  <div className="z-10 flex flex-col gap-0.5">
                    <Heading slot="title" className="text-md font-semibold text-primary">
                      Delete creator list?
                    </Heading>
                  </div>
                </div>
                <div className="z-10 flex flex-1 flex-col-reverse gap-3 p-4 pt-6 *:grow sm:grid sm:grid-cols-2 sm:px-6 sm:pt-8 sm:pb-6">
                  <Button color="secondary" size="lg" onClick={() => setOpen(false)}>
                    Cancel
                  </Button>
                  <Button color="primary-destructive" size="lg" type="submit">
                    Delete
                  </Button>
                </div>
              </div>
            </form>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};
